<div class="row">
  <div
    *ngFor="let col of columns"
    [class]="getColClass(col.cols) + ' col-wrapper'"
  >
    <ng-container #vc [ngTemplateOutlet]="col.child.templateRef"></ng-container>
  </div>
</div>
